import { useState } from 'react';

import {
  useMutation,
  // useQueryClient
} from '@tanstack/react-query';

import { toast } from 'sonner';

import { addToFavMutation } from '@/entities/payment';

import { Label, Switch, Typography } from '@/shared/ui';

export const AddToFavorites: React.FC<{ id: string; isFav?: boolean }> = ({
  id,
  isFav,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(isFav || false);
  const { mutateAsync } = useMutation({
    mutationFn: addToFavMutation,
  });
  //const queryClient = useQueryClient()
  const onChecked = async () => {
    try {
      await mutateAsync({ paymentId: id, isFavorite: !isChecked });
      setIsChecked((prev) => !prev);
      if (isChecked) {
        toast.success('Removed from favourites');
      } else {
        toast.success('Added to favourites');
      }
      // TODO: no isFav flag in payment/tx
      // await queryClient.invalidateQueries({
      //   queryKey: ['txs-list'],
      // });
      // await queryClient.invalidateQueries({
      //   queryKey: ['payments-list'],
      // });
    } catch (e) {
      console.log(e);
      toast.error('Failed to add to favorites');
      return;
    }
  };

  return (
    <>
      <Label className="flex w-full cursor-pointer items-center justify-between">
        <Typography>Add to favorites</Typography>
        <Switch onCheckedChange={onChecked} checked={isChecked} />
      </Label>
    </>
  );
};
